import * as React from "react";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {ProgressNumbering} from "../progress-numbering/progress-numbering";

import "./slide-carousel.scss";

export const SlideCarousel = ({slides}) => cs(
    ["activeIndex", (_, next) => UseState({next})],
    ({activeIndex}) => (
        <div className="image-section">
            {slides?.[activeIndex.value || 0] && (
                slides[activeIndex.value || 0]
            )}
            {slides?.length > 1 && (
                <div className="progress-numbering"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()}
                    }
                >
                    <ProgressNumbering {...{
                        index: activeIndex.value || 0,
                        total: slides.length || 0,
                        onChange: (index) => activeIndex.onChange(index),
                    }}/>
                </div>
            )}
            {!slides && <img src={require("../../../../../public/assets/NoImageAvailable.png")} alt="No Image Available"/>}
        </div>
    ),
);
